!(function () {
    "use strict";
    customElements.get("locations-component") ||
        customElements.define(
            "locations-component",
            class extends HTMLElement {
                constructor() {
                    super();

                    this.flkty = null;
                    this.flktyNav = null;

                    this.slider = null;
                    this.sliderNav = null;

                    this.resizeObserver = null;
                    this.rafResize = 0;

                    this.resizeEvent = () => this.enableAdaptiveHeight();

                    this.onNavChange = () => {
                        if (!this.flkty || !this.flktyNav) return;

                        this.flkty.selectCell(this.flktyNav.selectedIndex);

                        if (window.theme && window.theme.isMobile && window.theme.isMobile()) {
                            let { stickyHeaderHeight: e } = window.theme.readHeights();
                            const t = e || 0,
                                i = Math.round(window.scrollY),
                                s = Math.round(this.getBoundingClientRect().top + i - t);
                            window.scrollTo({ top: s, left: 0, behavior: "smooth" });
                        }
                    };

                    this.onMainChange = () => {
                        if (!this.flkty || !this.flktyNav) return;
                        this.flktyNav.selectCell(this.flkty.selectedIndex);
                    };

                    this.onWindowLoad = () => this.requestResize();
                }
                connectedCallback() {
                    this.slider = this.querySelector("[data-slider-gallery]");
                    this.sliderNav = this.querySelector("[data-slider-info]");

                    if (!this.slider || !this.sliderNav) return;
                    if (!window.theme || !window.theme.Flickity) return;

                    // Always destroy any existing instances first.
                    // This avoids duplicate Flickity instances after partial reloads/section re-renders.
                    const existingMain = window.theme.Flickity.data(this.slider);
                    const existingNav = window.theme.Flickity.data(this.sliderNav);
                    if (existingNav && existingNav.destroy) existingNav.destroy();
                    if (existingMain && existingMain.destroy) existingMain.destroy();
                    this.destroyFlickity();

                    const slideCount = this.sliderNav.querySelectorAll("[data-slide-item]").length;
                    if (slideCount <= 1) return;

                    // Defer init to the next frames to allow async CSS (preload->stylesheet swap)
                    // and layout to settle, preventing incorrect width measurements.
                    requestAnimationFrame(() =>
                        requestAnimationFrame(() => {
                            if (!this.isConnected) return;
                            if (!window.theme || !window.theme.Flickity) return;

                            this.flkty = new window.theme.Flickity(this.slider, {
                                fade: !0,
                                wrapAround: !0,
                                adaptiveHeight: !0,
                                prevNextButtons: !1,
                                pageDots: !1,
                                imagesLoaded: !0,
                            });

                            if (window.theme.flickitySmoothScrolling) {
                                window.theme.flickitySmoothScrolling(this.slider);
                            }

                            this.flktyNav = new window.theme.Flickity(this.sliderNav, {
                                fade: !0,
                                wrapAround: !0,
                                imagesLoaded: !0,
                                asNavFor: this.slider,
                                prevNextButtons: !0,
                                pageDots: !1,
                            });

                            this.enableAdaptiveHeight();
                            document.addEventListener("theme:resize", this.resizeEvent);
                            window.addEventListener("load", this.onWindowLoad, { once: !0 });

                            this.flktyNav.on("change", this.onNavChange);
                            this.flkty.on("change", this.onMainChange);

                            // Keep Flickity in sync with late CSS / font / image layout changes.
                            if (window.ResizeObserver) {
                                this.resizeObserver = new ResizeObserver(() => this.requestResize());
                                this.resizeObserver.observe(this);
                                this.resizeObserver.observe(this.slider);
                                this.resizeObserver.observe(this.sliderNav);
                            }

                            this.requestResize();
                        })
                    );
                }
                enableAdaptiveHeight() {
                    if (!this.flktyNav || !this.flktyNav.options) return;

                    this.flktyNav.options.adaptiveHeight = !1;
                    if (window.theme && window.theme.isMobile && window.theme.isMobile()) {
                        this.flktyNav.options.adaptiveHeight = !0;
                    }
                    this.flktyNav.resize();
                }

                requestResize() {
                    if (this.rafResize) cancelAnimationFrame(this.rafResize);
                    this.rafResize = requestAnimationFrame(() => {
                        this.rafResize = 0;
                        if (this.flkty && this.flkty.isActive) this.flkty.resize();
                        if (this.flktyNav && this.flktyNav.isActive) this.flktyNav.resize();
                    });
                }

                destroyFlickity() {
                    if (this.resizeObserver) {
                        this.resizeObserver.disconnect();
                        this.resizeObserver = null;
                    }
                    if (this.rafResize) {
                        cancelAnimationFrame(this.rafResize);
                        this.rafResize = 0;
                    }

                    if (this.flktyNav && this.flktyNav.off) {
                        this.flktyNav.off("change", this.onNavChange);
                    }
                    if (this.flkty && this.flkty.off) {
                        this.flkty.off("change", this.onMainChange);
                    }

                    if (this.flktyNav && this.flktyNav.destroy) {
                        this.flktyNav.destroy();
                    }
                    if (this.flkty && this.flkty.destroy) {
                        this.flkty.destroy();
                    }

                    this.flkty = null;
                    this.flktyNav = null;
                }

                disconnectedCallback() {
                    document.removeEventListener("theme:resize", this.resizeEvent);
                    window.removeEventListener("load", this.onWindowLoad);
                    this.destroyFlickity();
                }
            }
        );
})();
